import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HomeService } from 'src/app/home/services/home.service';
import { from } from 'rxjs';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.css']
})
export class HomeHeaderComponent implements OnInit {

  loadAPI: Promise<any>;
  constructor(  public globals: Globals ,public translate:  TranslateService,private homeService:HomeService ) {


    
   
   }

  
   langEn(lang){
    this.globals.useLTR(lang);
 
 
 
   }
 
   langAR(lang){
     this.globals.userRTL(lang);
 
 
 
   }

  ngOnInit() {
  }

}
